import React from "react";
import styles from "./CommandModals.module.scss";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import { LOADER_IMG } from "@whatslly/commons/constants";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { MessageModal } from "@whatslly/ui-components/modals/MessageModal";

const ScreenshotModal: React.FC<IModalInstance & { data: { screenshot?: string } }> = observer(({ closeModal, data }) => {
  return (
    <MessageModal closeModal={closeModal} bodyClassName={classnames({ [styles.screenshot]: data.screenshot })}>
      <div className={styles.loader}>
        <img src={data.screenshot ?? LOADER_IMG} data-testid="screenshot-image" />
      </div>
    </MessageModal>
  );
});

const DefaultModal: React.FC<IModalInstance & { data: { success?: boolean } }> = observer(({ closeModal, data }) => {
  return (
    <MessageModal closeModal={closeModal} testId="command-modal">
      <div className={styles.loader}>{data.success ? "Success" : <img src={LOADER_IMG} />}</div>
    </MessageModal>
  );
});

export const commandModals = { screenshot: ScreenshotModal, default: DefaultModal } as const;
